import accountDao from '../../dao/accountDao';
import {showTourHint} from '../layout/header/reducer';

const OPEN_TOUR_FIRST_TIME = 'components/tutorial/OPEN_TOUR_FIRST_TIME';
const OPEN_TOUR_MULTI_TIME = 'components/tutorial/OPEN_TOUR_MULTI_TIME';
const OPEN_TOUR = 'components/tutorial/OPEN_TOUR';
const CLOSE_TOUR = 'components/tutorial/CLOSE_TOUR';
const START_TOUR = 'components/tutorial/START_TOUR';
const STOP_TOUR = 'components/tutorial/STOP_TOUR';
const NEXT_STEP = 'components/tutorial/NEXT_STEP';
const UPDATE_STATUS = 'components/tutorial/UPDATE_STATUS';

const initialState = {
  isFirstTime: false,
  isOpened: false,
  status: {
    startTourOpened: false,
    addSkuLookTourViewed: false,
    productGroupTourViewed: false,
    moduleConfigurationTourViewed: false,
    apiIntegrationTourViewed: false,
    analyticsTourViewed: false,
    startTourOpenedEyewear: false,
    addEyewearFrameTourViewed: false,
    productEyewearTourViewed: false,
    lensTintEyewearTourViewed: false,
    moduleConfigurationTourEyewearViewed: false,
    apiIntegrationTourEyewearViewed: false,
    analyticsTourEyewearViewed: false,
    startTourOpenedSkincare: false,
  },
  tutorialMode: false,
  stepIndex: 0,
};
export default (state = initialState, action = {}) => {
  switch (action.type) {
    case OPEN_TOUR_FIRST_TIME:
      return {
        ...state,
        isFirstTime: true,
      };
    case OPEN_TOUR_MULTI_TIME:
      return {
        ...state,
        isFirstTime: false,
      };
    case OPEN_TOUR:
      return {
        ...state,
        isOpened: true,
      };
    case CLOSE_TOUR:
      return {
        ...state,
        isOpened: false,
      };
    case START_TOUR:
      return {
        ...state,
        tutorialMode: true,
        stepIndex: 0,
      };
    case STOP_TOUR:
      return {
        ...state,
        tutorialMode: false,
      };
    case NEXT_STEP:
      return {
        ...state,
        stepIndex: ++state.stepIndex,
      };
    case UPDATE_STATUS:
      return {
        ...state,
        status: {...state.status, ...action.status},
      };
    default:
      return state;
  }
};

export function openTourMultiTime() {
  return {
    type: OPEN_TOUR_MULTI_TIME,
  };
}

export function openTour() {
  return {
    type: OPEN_TOUR,
  };
}

export function closeTour() {
  return {
    type: CLOSE_TOUR,
  };
}

export function startTour() {
  return {
    type: START_TOUR,
  };
}

export function stopTour() {
  return {
    type: STOP_TOUR,
  };
}

export function nextStep() {
  return {
    type: NEXT_STEP,
  };
}

function updateStatus(status) {
  return {
    type: UPDATE_STATUS,
    status,
  };
}

export function tourTaskFinished(behaviorType) {
  return dispatch => {
    accountDao
      .createAccountEngagement(behaviorType)
      .then(status => dispatch(updateStatus(status)));
  };
}

export function checkAccountEngagement(functionType, auth) {
  return dispatch => {
    accountDao.queryAccountEngagement().then(status => {
      if (
        (functionType === 'MAKEUP' && status.startTourOpened) ||
        (functionType === 'EYEWEAR' && status.startTourOpenedEyewear) ||
        (functionType === 'SKINCARE_PRO' && status.startTourOpenedSkincare)
      ) {
        dispatch(updateStatus(status));
      } else if (
        functionType === 'SKINCARE_PRO' &&
        !status.startTourOpenedSkincare
      ) {
        const helpBtn = document.querySelector('#help-menu-button');
        if (helpBtn) {
          helpBtn.click();
        }
        dispatch(showTourHint());
        dispatch(tourTaskFinished('START_TOUR_OPENED_SKINCARE'));
      } else {
        dispatch(openTour());
        dispatch(
          tourTaskFinished(
            functionType === 'EYEWEAR'
              ? 'START_TOUR_OPENED_EYEWEAR'
              : 'START_TOUR_OPENED'
          )
        );
        dispatch({
          type: OPEN_TOUR_FIRST_TIME,
        });
      }
    });
  };
}
